<template>
    <modal v-model="openModal" :backdrop="false">
        <template v-slot:header>
            <div class="d-flex align-items-center justify-content-between">
                <button class="btn btn-circle" @click.prevent="openModal = false"><i class="fi fi-rr-arrow-left"></i></button>
                <input type="text" autofocus class="form-control bg-light-blue border-0 m-2" v-model="value" ref="search"
                       :placeholder="[roleService.ADMIN, roleService.SUPPER_ADMIN].includes(roles[0].name) ? trans('general.component.search.full_search') : trans('general.component.search.placeholder')" aria-label="Search" aria-describedby="basic-addon2">
            </div>
        </template>
        <template>
            <div class="w-100 list-group list-group-flush">
                <a class="list-group-item list-group-item-action fs-16 d-flex justify-content-between align-items-center"
                   v-for="item in items" :href="toUrl(item)">
                    <div class="d-flex align-items-center gap-2">
                        <img class="item-image cover center" :src="item.image ? item.image.sizes.sm : '/img/avatar.png'" height="30"
                             width="30" alt="">
                        <p class="mb-0 item-text text-capitalize ms-2 fw-bold">{{ item.name }} {{ item.surname }}</p>
                    </div>
                    <div class="type" v-html="getType(item)"></div>
                </a>
                <no-content-placeholder
                    v-if="items.length === 0"
                    icon="fi-rr-search"
                    title=""
                    :text="trans('general.component.search.no_results')"/>
            </div>
            <SearchEngine :value="value" v-on:response="handleResponse($event)"></SearchEngine>
        </template>
    </modal>
</template>

<script>
import SearchEngine from "../molecules/SearchEngine";
import Modal from "./Modal.vue";
import roleService, {roleToScope} from "../../services/RoleService";
import NoContentPlaceholder from "./NoContentPlaceholder.vue";

export default {
    name: "SearchModal",
    props: ['roles'],
    components: {
        'modal': Modal,
        SearchEngine,
        NoContentPlaceholder
    },
    data() {
        return {
            value: '',
            errors: [],
            openModal: false,
            items: [],
            roleService: roleService
        }
    },
    methods: {
        open() {
            this.openModal = true;
        },
        handleResponse(data) {
            this.items = data
        },
        toUrl(item) {
            if (item.roles && item.roles.some(role => role.name === this.roleService.ADMIN)) {
                return '/profile'
            }

            return item.roles && item.roles.length > 0 ? roleToScope(item.roles[0].name) + '/read/' + item.id : '/children/read/' + item.id
        },
        getType(item) {
            if (item.roles) {
                const rolesMap = {
                    [this.roleService.ADMIN]: 'admin',
                    [this.roleService.TEACHER]: 'teacher',
                    [this.roleService.PARENT]: 'parent',
                    [this.roleService.SUPER_ADMIN]: 'super_admin'
                };

                for (const role of item.roles) {
                    if (rolesMap[role.name]) {
                        return trans(`general.module.role.${rolesMap[role.name]}`);
                    }
                }
            }
            return trans('general.module.role.child');
        }
    }
}
</script>

<style >
.search-modal {
    width: 100% !important;
    margin: 0 !important;
    max-width: 100% !important;
    height: 100%;
}
.search-modal .modal-content{
    border-radius: 0!important;
    height: 100%;
    padding: 0;
}
.search-modal .modal-content .modal-body{
    padding: 0;
}
.search-modal .modal-content .modal-body .item-image{
    border-radius: 7px;
}
.type {
    font-size: 13px;
}
</style>
